// src/components/AdditionalInfoBox.js

import React, { useState } from 'react';
import icon1 from '../images/free2.svg';
import icon2 from '../images/patient_advocate.svg';
import icon3 from '../images/support.svg';

const items = [
  {
    icon: icon1,
    alt: 'Icon 1',
    title: 'Free',
    description:
      'Our service is completely free for our users with no hidden fees. We get compensated by the clinic and the cost is not reflected onto the user.',
  },
  {
    icon: icon2,
    alt: 'Icon 2',
    title: 'Patient-Advocate',
    description:
      'We have in-house attorneys experienced in healthcare law to ensure everything goes smoothly for our users, both before and after the procedure.',
  },
  {
    icon: icon3,
    alt: 'Icon 3',
    title: '24/7 Support',
    description:
      'You will have a specialist fluent in English assigned to you immediately after your booking who will be available 24/7 to answer your questions and solve your problems.',
  },
];

const AdditionalInfoBox = () => {
  // main accordion open/closed
  const [mainExpanded, setMainExpanded] = useState(false);
  // per-item rows
  const [expandedRows, setExpandedRows] = useState(
    Array(items.length).fill(false)
  );

  const toggleRow = (index) => {
    setExpandedRows((prev) => {
      const next = [...prev];
      next[index] = !next[index];
      return next;
    });
  };

  return (
    <div className="mt-4">
      {/* Main header */}
      <div
        className="relative cursor-pointer"
        onClick={() => setMainExpanded((prev) => !prev)}
      >
        <h2 className="text-2xl font-extrabold text-mm_blue text-center">
          Why use us?
        </h2>
        <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
          {mainExpanded ? (
            // up chevron
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-gray-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 15l7-7 7 7"
              />
            </svg>
          ) : (
            // down chevron
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-gray-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          )}
        </div>
      </div>

      {/* Only show items when mainExpanded */}
      {mainExpanded && (
        <table className="w-full border-collapse">
          <tbody>
            {items.map((item, idx) => (
              <React.Fragment key={idx}>
                <tr
                  onClick={() => toggleRow(idx)}
                  className="cursor-pointer"
                >
                  <td className="w-1/6 p-2">
                    <img
                      src={item.icon}
                      alt={item.alt}
                      className="w-6 h-6"
                    />
                  </td>
                  <td className="w-full p-2 flex items-center justify-between text-xl font-extrabold text-gray-700">
                    <span>{item.title}</span>
                    <span>
                      {expandedRows[idx] ? (
                        // up chevron
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 15l7-7 7 7"
                          />
                        </svg>
                      ) : (
                        // down chevron
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      )}
                    </span>
                  </td>
                </tr>
                {expandedRows[idx] && (
                  <tr>
                    <td
                      colSpan={2}
                      className="p-2 text-left text-base text-gray-600 text-justify"
                    >
                      {item.description}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdditionalInfoBox;
